import {
  SPR_boss1,
  SPR_boss2,
  SPR_bossFinal,
  SPR_enemyA,
  SPR_enemyB,
  SPR_enemyC,
  SPR_enemyD,
  SPR_enemyE,
  SPR_enemyF,
  SPR_generator,
  SPR_mine,
} from "../assets";
import type { SheetClass } from "../data/entitySheets";

export interface EntitySprite {
  readonly sheet: SheetClass;
  readonly largeEffects?: boolean;
}

/** Semantic authored sprite keys backed by compiled asset classes. */
export const ENTITY_SPRITES: Readonly<Record<string, EntitySprite>> = {
  "enemy-a": { sheet: SPR_enemyA },
  "enemy-b": { sheet: SPR_enemyB },
  "enemy-c": { sheet: SPR_enemyC },
  "enemy-d": { sheet: SPR_enemyD },
  "enemy-e": { sheet: SPR_enemyE, largeEffects: true },
  "enemy-f": { sheet: SPR_enemyF, largeEffects: true },
  mine: { sheet: SPR_mine, largeEffects: true },
  generator: { sheet: SPR_generator, largeEffects: true },
  "boss-1": { sheet: SPR_boss1, largeEffects: true },
  "boss-2": { sheet: SPR_boss2, largeEffects: true },
  "boss-final": { sheet: SPR_bossFinal, largeEffects: true },
};

export function resolveEntitySprite(key: string): EntitySprite {
  const sprite = ENTITY_SPRITES[key];
  if (sprite === undefined) throw new Error(`unknown entity sprite '${key}'`);
  return sprite;
}
